var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 54,
    viewBox: "0 0 38 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.3333C2 8.1232 2.87797 6.00358 4.44078 4.44078C6.00358 2.87797 8.1232 2 10.3333 2H18.6667V18.6667H10.3333C8.1232 18.6667 6.00358 17.7887 4.44078 16.2259C2.87797 14.6631 2 12.5435 2 10.3333Z",
    stroke: "#C9C9C9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 2H27C28.0943 2 29.178 2.21555 30.189 2.63434C31.2001 3.05313 32.1187 3.66696 32.8925 4.44078C33.6664 5.2146 34.2802 6.13326 34.699 7.1443C35.1178 8.15535 35.3333 9.23898 35.3333 10.3333C35.3333 11.4277 35.1178 12.5113 34.699 13.5224C34.2802 14.5334 33.6664 15.4521 32.8925 16.2259C32.1187 16.9997 31.2001 17.6135 30.189 18.0323C29.178 18.4511 28.0943 18.6667 27 18.6667H18.6667V2Z",
    stroke: "#C9C9C9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 27C18.6667 25.9056 18.8822 24.822 19.301 23.8109C19.7198 22.7999 20.3336 21.8812 21.1074 21.1074C21.8813 20.3336 22.7999 19.7198 23.811 19.301C24.822 18.8822 25.9056 18.6666 27 18.6666C28.0943 18.6666 29.178 18.8822 30.189 19.301C31.2001 19.7198 32.1187 20.3336 32.8925 21.1074C33.6664 21.8812 34.2802 22.7999 34.699 23.8109C35.1178 24.822 35.3333 25.9056 35.3333 27C35.3333 28.0943 35.1178 29.1779 34.699 30.189C34.2802 31.2 33.6664 32.1187 32.8925 32.8925C32.1187 33.6663 31.2001 34.2802 30.189 34.699C29.178 35.1177 28.0943 35.3333 27 35.3333C25.9056 35.3333 24.822 35.1177 23.811 34.699C22.7999 34.2802 21.8813 33.6663 21.1074 32.8925C20.3336 32.1187 19.7198 31.2 19.301 30.189C18.8822 29.1779 18.6667 28.0943 18.6667 27V27Z",
    stroke: "#C9C9C9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 43.6667C2 41.4566 2.87797 39.337 4.44078 37.7741C6.00358 36.2113 8.1232 35.3334 10.3333 35.3334H18.6667V43.6667C18.6667 45.8768 17.7887 47.9965 16.2259 49.5593C14.6631 51.1221 12.5435 52 10.3333 52C8.1232 52 6.00358 51.1221 4.44078 49.5593C2.87797 47.9965 2 45.8768 2 43.6667Z",
    stroke: "#C9C9C9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27C2 24.7898 2.87797 22.6702 4.44078 21.1074C6.00358 19.5446 8.1232 18.6666 10.3333 18.6666H18.6667V35.3333H10.3333C8.1232 35.3333 6.00358 34.4553 4.44078 32.8925C2.87797 31.3297 2 29.2101 2 27Z",
    stroke: "#C9C9C9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.4a007bbfb40521ade8af30d262e90869.svg";
export { ForwardRef as ReactComponent };